import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { CustomsEntryHeader } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomsEntryHeaderService extends TmsWebBaseEditService<CustomsEntryHeader, CustomsEntryHeader> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('CustomsEntryHeader', $localize`Customs Entry Header`);
  }
}
